import { SET_GUEST_BULK_PICKUP_ACCORDION_DATA } from "constants-lib/actionTypes"

export const setGuestBulkPickupAccordionData = (data) => (dispatch) =>
  dispatch({
    type: SET_GUEST_BULK_PICKUP_ACCORDION_DATA,
    payload: data,
  })
